// @flow

export const WIDGET_MAY_KNOW_INITIATING = 'WIDGET_MAY_KNOW_INITIATING'
export const WIDGET_MAY_KNOW_INITIATED = 'WIDGET_MAY_KNOW_INITIATED'
export const WIDGET_MAY_KNOW_ERROR = 'WIDGET_MAY_KNOW_ERROR'
